/** Polskie nazwy typów obiektów i operacji w historii (audycie). */

export const ENTITY_LABELS: Record<string, string> = {
  sprawa: 'Sprawa',
  kontrahent: 'Kontrahent',
  lokalizacja: 'Lokalizacja',
  firma: 'Firma',
  seria_numeracji: 'Seria numeracji',
  uzytkownik: 'Użytkownik',
  rola: 'Rola',
  branza: 'Branża',
  oddzial: 'Oddział',
  szablon_procesu: 'Szablon procesu',
  katalog: 'Pozycja katalogu',
  szablon: 'Szablon dokumentu',
  ekipa: 'Ekipa',
  kalendarz: 'Wpis kalendarza',
  zgloszenie: 'Zgłoszenie serwisowe',
  instalacja: 'Instalacja',
  zadanie: 'Zadanie',
  magazyn: 'Magazyn',
  dokument_magazynowy: 'Dokument magazynowy',
  inwentaryzacja: 'Inwentaryzacja',
  grupa_produktow: 'Grupa produktów',
  pakiet: 'Pakiet materiałów',
  zamowienie: 'Zamówienie do dostawcy',
  dostawca: 'Dostawca',
  zapotrzebowanie: 'Zapotrzebowanie',
  ustawienia: 'Ustawienia',
};

export const ACTION_LABELS: Record<string, string> = {
  logowanie: 'Logowanie',
  'logowanie.nieudane': 'Nieudane logowanie',
  wylogowanie: 'Wylogowanie',
  'firma.utworzenie': 'Utworzenie firmy',
  'firma.edycja': 'Zmiana danych firmy',
  'seria.zmiana_wzoru': 'Zmiana wzoru numeracji',
  'uzytkownik.utworzenie': 'Utworzenie konta',
  'uzytkownik.edycja': 'Zmiana konta (dane, role, firmy, aktywność)',
  'uzytkownik.zmiana_hasla': 'Ustawienie nowego hasła',
  'uzytkownik.zmiana_hasla.nieudana': 'Nieudana zmiana własnego hasła',
  'rola.utworzenie': 'Utworzenie roli',
  'rola.uprawnienia': 'Zmiana uprawnień roli',
  'rola.kolejki': 'Zmiana kolejek zadań roli',
  'branza.edycja': 'Zmiana branży',
  'oddzial.utworzenie': 'Utworzenie oddziału',
  'oddzial.edycja': 'Zmiana oddziału',
  'szablon_procesu.edycja': 'Zmiana szablonu procesu',
  'kontrahent.utworzenie': 'Utworzenie kontrahenta',
  'kontrahent.utworzenie_mimo_duplikatu': 'Utworzenie kontrahenta mimo ostrzeżenia o duplikacie',
  'kontrahent.edycja': 'Zmiana danych kontrahenta',
  'kontakt.dodanie': 'Dodanie osoby kontaktowej',
  'kontakt.edycja': 'Zmiana osoby kontaktowej',
  'kontakt.usuniecie': 'Usunięcie osoby kontaktowej',
  'lokalizacja.utworzenie': 'Utworzenie lokalizacji',
  'lokalizacja.edycja': 'Zmiana lokalizacji',
  'lokalizacja.powiazanie': 'Powiązanie kontrahenta z lokalizacją',
  'lokalizacja.odlaczenie': 'Odłączenie kontrahenta od lokalizacji',
  'sprawa.utworzenie': 'Utworzenie sprawy',
  'sprawa.edycja': 'Zmiana danych sprawy',
  'sprawa.etap': 'Zmiana etapu sprawy',
  'sprawa.opiekun': 'Zmiana opiekuna',
  'sprawa.odrzucenie': 'Zamknięcie jako odrzucone zapytanie',
  'sprawa.wznowienie': 'Wznowienie sprawy',
  'sprawa.proba_kontaktu': 'Próba kontaktu z klientem',
  'sprawa.wstrzymanie': 'Wstrzymanie sprawy',
  'sprawa.wznowienie_wstrzymanej': 'Wznowienie wstrzymanej sprawy',
  'sprawa.powiadomienie_klienta': 'Informacja dla klienta o wstrzymaniu / wznowieniu / zamknięciu sprawy',
  'sprawa.przedluzenie_wstrzymania': 'Przedłużenie wstrzymania sprawy',
  'sprawa.notatka': 'Dodanie notatki',
  'zakres.dodanie': 'Dodanie zakresu prac',
  'zakres.edycja': 'Zmiana opisu zakresu',
  'zakres.zmiana_firmy': 'Zmiana firmy zakresu',
  'zakres.przegrany': 'Zakres przegrany',
  'zakres.wstrzymanie': 'Wstrzymanie zakresu',
  'zakres.wznowienie': 'Wznowienie zakresu',
  'zakres.usuniecie': 'Usunięcie zakresu',
  'krok.dodanie': 'Dodanie kroku procesu',
  'krok.zmiana': 'Zmiana kroku procesu',
  'krok.zrobiony': 'Krok wykonany',
  'krok.pominiecie': 'Pominięcie kroku',
  'krok.przywrocenie': 'Przywrócenie pominiętego kroku',
  'krok.kolejnosc': 'Zmiana kolejności kroków',
  'krok.usuniecie': 'Usunięcie kroku',
  'zakres.etap': 'Zmiana etapu sprzedaży zakresu (z dokumentów)',
  'katalog.utworzenie': 'Dodanie pozycji katalogu',
  'katalog.edycja': 'Zmiana pozycji katalogu',
  'katalog.zmiana_ceny': 'Zmiana ceny w cenniku',
  'katalog.zalacznik': 'Dodanie załącznika',
  'katalog.zalacznik_usuniety': 'Usunięcie załącznika',
  'katalog.cena_bazowa': 'Zapis ceny bazowej na karcie produktu',
  'grupa.utworzenie': 'Dodanie grupy produktów',
  'grupa.edycja': 'Zmiana grupy produktów',
  'magazyn.utworzenie': 'Dodanie magazynu',
  'magazyn.edycja': 'Zmiana magazynu',
  'magazyn.miejsce': 'Zmiana miejsca składowania / minimum',
  'uzytkownik.magazyny': 'Zmiana magazynów pracownika',
  'dokument_mag.utworzenie': 'Utworzenie dokumentu magazynowego',
  'dokument_mag.edycja': 'Zmiana dokumentu roboczego',
  'dokument_mag.zatwierdzenie': 'Zatwierdzenie dokumentu magazynowego',
  'dokument_mag.usuniecie': 'Usunięcie dokumentu roboczego',
  'dokument_mag.odwrocenie': 'Odwrócenie dokumentu magazynowego',
  'inwentaryzacja.rozpoczecie': 'Rozpoczęcie inwentaryzacji',
  'inwentaryzacja.spis': 'Wpis spisu z natury',
  'inwentaryzacja.zamkniecie': 'Zamknięcie inwentaryzacji',
  'inwentaryzacja.anulowanie': 'Anulowanie inwentaryzacji',
  'ustawienia.zmiana': 'Zmiana ustawień',
  'oferta.utworzenie': 'Utworzenie oferty',
  'oferta.edycja_robocza': 'Zmiana wersji roboczej oferty',
  'oferta.wydanie': 'Wydanie oferty',
  'oferta.wydanie_ponizej_progu': 'Wydanie oferty z wyjątkiem (rabat / marża poza progiem)',
  'oferta.prosba_o_wydanie': 'Prośba o wydanie oferty z wyjątkiem (rabat / marża)',
  'oferta.prosba_odrzucona': 'Odrzucenie prośby o wydanie oferty z wyjątkiem',
  'oferta.ustalenia_umowy': 'Zmiana ustaleń do umowy w ofercie (zaliczka, forma podpisu, uwagi)',
  'oferta.wygasniecie': 'Wygaśnięcie oferty (termin ważności minął)',
  'oferta.nowa_wersja': 'Nowa wersja oferty',
  'oferta.usuniecie_roboczej': 'Usunięcie wersji roboczej',
  'oferta.wycofanie': 'Wycofanie oferty',
  'oferta.akceptacja': 'Akceptacja oferty',
  'oferta.wycofanie_akceptacji': 'Wycofanie akceptacji',
  'link.utworzenie': 'Utworzenie linku dla klienta',
  'link.otwarcie': 'Pierwsze otwarcie linku przez klienta',
  'link.uniewaznienie': 'Unieważnienie linku',
  'strefa.wyslanie': 'Link do strefy klienta (harmonogram prac, umowy, oferty)',
  'strefa.wejscie': 'Klient wszedł do strefy klienta (kod z e-maila)',
  'strefa.prosba_terminu': 'Klient poprosił w strefie o zmianę terminu pracy',
  'strefa.prosba_terminu_odpowiedz': 'Odpowiedź klientowi na prośbę o zmianę terminu (termin bez zmian)',
  'strefa.uniewaznienie': 'Wyłączenie linku do strefy klienta',
  'platnosc.rozliczenie': 'Zmiana rozliczenia płatności',
  'protokol.poprawka': 'Zlecenie poprawki',
  'protokol.uwagi_rozpatrzone': 'Rozpatrzenie uwag w protokole',
  'szablon.utworzenie': 'Utworzenie szablonu',
  'szablon.nowa_wersja': 'Nowa wersja szablonu',
  'szablon.ustawienia': 'Zmiana ustawień szablonu',
  'umowa.utworzenie': 'Przygotowanie umowy',
  'umowa.edycja_robocza': 'Zmiana umowy roboczej',
  'umowa.wydanie': 'Wydanie umowy do podpisu',
  'umowa.podpis': 'Odnotowanie podpisu umowy',
  'urzadzenie.rejestracja': 'Rejestracja urządzenia mobilnego',
  'urzadzenie.uniewaznienie': 'Unieważnienie urządzenia mobilnego',
  'zadanie.blokada_rozwiazana': 'Rozwiązanie blokady zadania',
  'zadanie.sprawdzono': 'Sprawdzenie zdarzenia z terenu',
  'zadanie.utworzenie': 'Utworzenie zadania',
  'zadanie.planowanie': 'Zaplanowanie zadania',
  'zadanie.zmiana_terminu': 'Zmiana terminu zadania',
  'zadanie.planowanie_mimo_konfliktu': 'Zaplanowanie mimo konfliktu',
  'zadanie.cofniecie_planu': 'Cofnięcie zadania do kolejki',
  'zadanie.anulowanie': 'Anulowanie zadania',
  'zadanie.planowanie_mimo_brakow': 'Zaplanowanie mimo braków materiałowych',
  'zakres.planowany_termin': 'Planowany termin realizacji zakresu',
  'zapotrzebowanie.z_umowy': 'Zapotrzebowanie materiałów z umowy',
  'zadanie.powiadomienie_klienta': 'Informacja dla klienta o terminie prac',
  'zadanie.przeliczenie_skladu': 'Przeliczenie przydziałów po zmianie składu ekipy',
  'ekipa.utworzenie': 'Utworzenie ekipy',
  'ekipa.zmiana': 'Zmiana ekipy',
  'ekipa.sklad': 'Zmiana składu ekipy',
  'ekipa.sklad_koniec': 'Zakończenie członkostwa w ekipie',
  'nieobecnosc.wniosek': 'Wniosek o nieobecność',
  'nieobecnosc.wpis': 'Wpis nieobecności',
  'nieobecnosc.zatwierdzenie': 'Zatwierdzenie nieobecności',
  'nieobecnosc.odrzucenie': 'Odrzucenie wniosku o nieobecność',
  'kalendarz.wpis': 'Wpis w kalendarzu',
  'kalendarz.wycofanie_wpisu': 'Wycofanie wpisu z kalendarza',
  'oferta.odrzucenie': 'Odrzucenie oferty przez klienta',
  'epodpis.wyslanie': 'Wysłanie do podpisu elektronicznego',
  'epodpis.podpis': 'Podpis elektroniczny',
  'epodpis.odmowa': 'Odmowa podpisu elektronicznego',
  'epodpis.anulowanie': 'Anulowanie podpisu elektronicznego',
  'epodpis.ponowny_link': 'Ponowna wysyłka linku do podpisu',
  'epodpis.przypomnienie': 'Przypomnienie o podpisie w imieniu firmy',
  'epodpis.zmiana_podpisujacego': 'Zmiana osoby podpisującej w imieniu firmy',
  'epodpis.zakonczenie': 'Zakończenie podpisu elektronicznego',
  'umowa.anulowanie': 'Anulowanie umowy',
  'umowa.usuniecie_roboczej': 'Usunięcie dokumentu roboczego',
  'aneks.utworzenie': 'Przygotowanie aneksu',
  'aneks.wydanie': 'Wydanie aneksu do podpisu',
  'aneks.podpis': 'Odnotowanie podpisu aneksu',
  'aneks.anulowanie': 'Anulowanie aneksu',
  'wplata.rejestracja': 'Rejestracja wpłaty',
  'wplata.storno': 'Storno wpłaty',
  'wplata.nadplata_online': 'Nadpłata z płatności online',
  'wplata.nadplata_zwrot': 'Zwrot nadpłaty online',
  'sprzedaz.platnosc_pozniej': 'Sprzedaż w terenie: klient zapłaci później',
  'platnosc.harmonogram': 'Harmonogram płatności dla klienta',
  'platnosc.przypomnienie': 'Przypomnienie klientowi o płatności',
  'platnosc.prosba_o_przypomnienie': 'Prośba do księgowości o przypomnienie klientowi',
  'platnosc.wplata_zgloszona': 'Klient zgłosił wpłatę (czeka na zaksięgowanie)',
  'warunki.odstepstwo': 'Odstępstwo od warunków startu',
  'warunki.odstepstwo_cofniete': 'Cofnięcie odstępstwa',
  'dokument.dodanie': 'Dodanie dokumentu',
  'dokument.usuniecie': 'Usunięcie dokumentu',
  'faktura.zlecenie': 'Wysłanie faktury do Fakturowni',
  'faktura.wystawiona': 'Wystawienie faktury',
  'faktura.blad': 'Błąd wystawienia faktury',
  'faktura.korekta': 'Faktura korygująca',
  'integracja.konfiguracja': 'Konfiguracja integracji',
  'integracja.token': 'Zmiana tokenu integracji',
  // przyjęcie zgłoszenia i zamknięcie sprawy (QA P8), wysyłka faktury (QA P7)
  'sprawa.przejecie': 'Przejęcie sprawy',
  'sprawa.do_uzupelnienia': 'Skierowanie do uzupełnienia',
  'sprawa.uzupelniono': 'Uzupełnienie danych zgłoszenia',
  'sprawa.nadanie_biegu': 'Nadanie biegu sprawie',
  'sprawa.przegrana': 'Zamknięcie sprawy jako przegranej',
  'sprawa.duplikat': 'Zamknięcie jako duplikat',
  'sprawa.dolaczono_duplikat': 'Dołączenie zgłoszenia jako duplikatu',
  'sprawa.weryfikacja_koncowa': 'Weryfikacja końcowa sprawy',
  'sprawa.zamkniecie_automatyczne': 'Automatyczne zamknięcie sprawy',
  'faktura.wysylka': 'Wysłanie dokumentu klientowi',
  'sprawa.zakonczenie': 'Zakończenie sprawy',
  'sprawa.zamkniecie_wyjatkowe': 'Wyjątkowe zamknięcie sprawy',
  'oferta.przekazanie': 'Przekazanie oferty klientowi',
  'oferta.do_zmiany': 'Odesłanie oferty do zmiany',
  'oferta.dopisanie_czesci': 'Dopisanie części oferty',
  'oferta.czesc_gotowa': 'Część oferty gotowa',
  'oferta.czesc_cofnieta': 'Cofnięcie gotowości części oferty',
  'umowa.do_zmiany': 'Zmiany klienta w umowie przed podpisem',
  'aneks.do_zmiany': 'Zmiany klienta w aneksie przed podpisem',
  'umowa.wyslanie_do_podpisu': 'Wysłanie klientowi dokumentu do podpisu papierowego',
  'umowa.prosba_o_epodpis': 'Prośba klienta o podpis elektroniczny (do działu umów)',
  'umowa.oryginal_otrzymany': 'Otrzymano oryginał dokumentu podpisanego papierowo',
  'zlecenie.utworzenie': 'Utworzenie zlecenia (bez umowy)',
  'sprzedaz.podpis': 'Sprzedaż w terenie: podpis klienta i płatność',
  'sprzedaz.rezerwacja': 'Sprzedaż w terenie: wstępna rezerwacja terminu',
  'sprzedaz.porzucenie': 'Sprzedaż w terenie: przerwana',
  'sprzedaz.do_biura': 'Sprzedaż w terenie: ofertę przygotuje biuro (powyżej progu umowy)',
  'korespondencja.przypiecie': 'Korespondencja z klientem przypięta do sprawy',
  'korespondencja.odpiecie': 'Korespondencja z klientem odpięta od sprawy',
  'korespondencja.odpowiedz': 'Odpowiedź do klienta (korespondencja)',
  'korespondencja.nowa': 'Nowa wiadomość do klienta (korespondencja)',
  'korespondencja.import': 'Import maili od klienta ze skrzynki firmy',
  'dokument.zmiana': 'Zmiana opisu dokumentu',
  'protokol.uniewaznienie': 'Unieważnienie protokołu',
  'protokol.wysylka_ponowna': 'Ponowna wysyłka protokołu',
  'zadanie.wycofanie_wstrzymanie': 'Wycofanie pracy z terminu (wstrzymanie)',
  // zgłoszenia serwisowe (QA qa10302046 P18 — historia na panelu zgłoszenia)
  'zgloszenie.utworzenie': 'Utworzenie zgłoszenia',
  'zgloszenie.zmiana': 'Zmiana zgłoszenia',
  'zgloszenie.do_umowienia': 'Zgłoszenie do umówienia',
  'zgloszenie.wykonane': 'Zgłoszenie wykonane',
  'zgloszenie.zamknij': 'Zamknięcie zgłoszenia',
  'zgloszenie.anuluj': 'Anulowanie zgłoszenia',
  'zgloszenie.reklamacja': 'Reklamacja u producenta',
  'protokol.doslanie': 'Dosłanie niedoręczonego protokołu',
  'reklamacja.termin': 'Termin decyzji producenta (przypomnienie)',
  'reklamacja.odrzucona': 'Reklamacja odrzucona przez producenta',
  'zgloszenie.rozliczenie': 'Rozliczenie naprawy',
  'zgloszenie.faktura': 'Faktura za serwis wystawiona',
  // docs/26: rozliczenie serwisu
  'zgloszenie.pozycje': 'Pozycje do zapłaty',
  'zgloszenie.wplata': 'Wpłata online za serwis',
  'zgloszenie.link_platnosci': 'Link do zapłaty wysłany',
  'zgloszenie.faktura_blad': 'Faktura za serwis — błąd wystawienia',
  'zgloszenie.faktura_wyslana': 'Faktura za serwis wysłana do klienta',
  'protokol.doreczono_poza_email': 'Protokół doręczony poza e-mailem',
};

export const SOURCE_LABELS: Record<string, string> = {
  web: 'aplikacja biurowa',
  mobile: 'aplikacja mobilna',
  link: 'link klienta',
  system: 'system',
};
